export default __webpack_public_path__ + "static/media/Rede_Vida.4b74b667.png";